<template>
  <div
    class="section-title"
    :class="{ 'pt-10 pb-5': !disablePadding}"
  >
    {{ capitalize(title) }}
  </div>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    disablePadding: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    capitalize,
  },
};
</script>
<style lang="css" scoped>
.section-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.01em;
}
</style>